document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-scent-section]')
  if (!section) return

  const tabs = Array.from(section.querySelectorAll('[data-scent-tab]'))
  const panels = Array.from(section.querySelectorAll('[data-scent-panel]'))
  const mpanels = Array.from(section.querySelectorAll('[data-scent-mpanel]'))
  const backgrounds = Array.from(section.querySelectorAll('[data-scent-bg]'))
  const segments = Array.from(section.querySelectorAll('[data-scent-progress]'))
  const mobile = section.querySelector('[data-scent-mobile]')
  const prev = section.querySelector('[data-scent-prev]')
  const next = section.querySelector('[data-scent-next]')

  const count = Math.max(panels.length, mpanels.length)

  let active = 0
  let scrollDriven = false

  const revealNotes = (panel) => {
    if (!window.gsap || !panel || !panel.offsetParent) return

    const notes = Array.from(panel.querySelectorAll('[data-scent-note]'))
    if (!notes.length) return

    window.gsap.fromTo(
      notes,
      { autoAlpha: 0, y: 20 },
      { autoAlpha: 1, y: 0, duration: 0.9, ease: 'power3.out', stagger: 0.12, overwrite: true },
    )
  }

  const revealActiveNotes = () => {
    revealNotes(panels[active])
    revealNotes(mpanels[active])
  }

  if (count) {
    const setArrowStyle = (button, isOutlined) => {
      if (!button) return
      button.classList.toggle('border', isOutlined)
      button.classList.toggle('border-white-100/20', isOutlined)
      button.classList.toggle('text-cream-100', isOutlined)
      button.classList.toggle('bg-white-100', !isOutlined)
      button.classList.toggle('text-black-200', !isOutlined)
    }

    const render = () => {
      tabs.forEach((tab, i) => {
        tab.classList.toggle('text-cream-100', i === active)
        tab.classList.toggle('text-white-100/40', i !== active)
      })
      panels.forEach((panel, i) => {
        panel.classList.toggle('invisible', i !== active)
      })
      mpanels.forEach((panel, i) => {
        panel.classList.toggle('invisible', i !== active)
      })
      backgrounds.forEach((bg) => {
        bg.classList.toggle('opacity-0', Number(bg.dataset.index) !== active)
      })

      setArrowStyle(prev, active === 0)
      setArrowStyle(next, active === count - 1)

      if (!scrollDriven) {
        segments.forEach((segment) => {
          const index = Number(segment.dataset.index)
          segment.classList.toggle('scale-x-100', index <= active)
          segment.classList.toggle('scale-x-0', index > active)
        })
      }
    }

    const setActive = (index) => {
      const target = Math.max(0, Math.min(index, count - 1))
      if (target === active) return
      active = target
      render()
      revealActiveNotes()
    }

    let goTo = (index) => setActive(index)
    let step = (delta) => goTo(active + delta)

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => goTo(Number(tab.dataset.index)))
    })

    prev?.addEventListener('click', () => step(-1))
    next?.addEventListener('click', () => step(1))

    if (mobile && count > 1) {
      const SWIPE_LOCK = 10
      const SWIPE_THRESHOLD = 50
      let startX = 0
      let startY = 0
      let isHorizontal = null

      mobile.addEventListener(
        'touchstart',
        (event) => {
          startX = event.touches[0].clientX
          startY = event.touches[0].clientY
          isHorizontal = null
        },
        { passive: true },
      )

      mobile.addEventListener(
        'touchmove',
        (event) => {
          const deltaX = event.touches[0].clientX - startX
          const deltaY = event.touches[0].clientY - startY

          if (isHorizontal === null) {
            if (Math.abs(deltaX) < SWIPE_LOCK && Math.abs(deltaY) < SWIPE_LOCK) return
            isHorizontal = Math.abs(deltaX) > Math.abs(deltaY)
          }

          if (isHorizontal) event.preventDefault()
        },
        { passive: false },
      )

      mobile.addEventListener('touchend', (event) => {
        if (!isHorizontal) return
        const deltaX = startX - event.changedTouches[0].clientX
        if (deltaX > SWIPE_THRESHOLD) step(1)
        else if (deltaX < -SWIPE_THRESHOLD) step(-1)
      })
    }

    if (window.gsap && window.ScrollTrigger && segments.length) {
      const { gsap } = window
      const SCROLL_PER_NOTE = 0.8

      const setupPin = () =>
        gsap.matchMedia().add('(min-width: 1200px)', () => {
          scrollDriven = true

          const timeline = gsap.timeline({
            paused: true,
            defaults: { ease: 'none' },
            onUpdate: () => setActive(Math.floor(timeline.progress() * count)),
          })

          segments.forEach((segment) => {
            timeline.fromTo(segment, { scaleX: 0 }, { scaleX: 1, duration: 1 }, Number(segment.dataset.index))
          })

          const trigger = window.ScrollTrigger.create({
            trigger: section,
            start: 'top top',
            end: () => `+=${count * window.innerHeight * SCROLL_PER_NOTE}`,
            pin: section,
            pinSpacing: true,
            scrub: 1,
            refreshPriority: 1,
            invalidateOnRefresh: true,
            animation: timeline,
          })

          window.ScrollTrigger.refresh()

          goTo = (index) => {
            const target = Math.max(0, Math.min(index, count - 1))
            const y = trigger.start + ((target + 0.5) / count) * (trigger.end - trigger.start)

            if (window.lenis) window.lenis.scrollTo(y, { immediate: true })
            else window.scrollTo(0, y)
          }

          step = (delta) => goTo(Math.min(Math.floor(trigger.progress * count), count - 1) + delta)

          section.querySelectorAll('img').forEach((image) => {
            if (!image.complete) image.addEventListener('load', () => window.ScrollTrigger.refresh(), { once: true })
          })

          return () => {
            scrollDriven = false
            trigger.kill()
            timeline.kill()
            segments.forEach((segment) => gsap.set(segment, { clearProps: 'transform' }))
            goTo = (index) => setActive(index)
            step = (delta) => goTo(active + delta)
            render()
          }
        })

      if (window.whenScrollReady) window.whenScrollReady(setupPin)
      else setupPin()
    }

    render()
  }

  const reveals = Array.from(section.querySelectorAll('[data-scent-reveal]'))

  const reveal = () => {
    if (!window.gsap) {
      reveals.forEach((el) => el.classList.remove('opacity-0'))
      return
    }

    const { gsap } = window
    gsap.fromTo(reveals, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, duration: 1.1, ease: 'power3.out' })
    revealActiveNotes()
  }

  const reset = () => {
    if (!window.gsap) return
    const { gsap } = window
    gsap.set(reveals, { autoAlpha: 0, y: 30 })
  }

  if (window.gsap && window.ScrollTrigger) {
    reset()
    window.ScrollTrigger.create({ trigger: section, start: 'top 70%', onEnter: reveal })
    window.ScrollTrigger.create({ trigger: section, start: 'top bottom', onLeaveBack: reset })
  } else {
    reveal()
  }
})
